<template>
  <div class="station-details">
    <div class="info-layout">
      <h3>
        Information
        <icon-button icon="el-icon-setting" @click="$emit('edit')" v-if="$auth.user.isSystem" />
      </h3>
      <p>
        <span>
          {{ station.address }} <br/>
        </span>
        Address
      </p>

      <p>
        <span>
          {{ station.zip }} <br/>
        </span>
        Zip
      </p>

      <p>
        <span>
          {{ station.city }} <br/>
        </span>
        City
      </p>

      <p v-if="$auth.user.isSystem">
        <span>{{ station.refId }}</span>
        Reference ID
      </p>

      <p>
        <span>{{ station.description }}</span>
        Description
      </p>

      <station-map
          style="margin: 20px 20px;"
          :stations="stations"
          :map-only="true"
          height="250"
          :zoom="15"
          :disableScrollZoom="true"
          :center="[getLocation[0], getLocation[1]]"/>
    </div>
  </div>
</template>

<script>
import StationMap from '@/components/dashboard/stations/map/StationMap'

export default {
  name: 'StationDetails',
  components: { StationMap },
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  watch: {
    'station' () {
      this.stations.pop()
      this.stations.push(this.station)
    }
  },
  computed: {
    getLocation () {
      return this.station.locationCoordinates.split(',')
    }
  },
  data () {
    return {
      stations: []
    }
  },
  created () {
    this.stations.push(this.station)
  }
}
</script>

<style lang="scss" scoped>
  .info {
    h3 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #DCDFE6;
      color: #909399;
      text-transform: none;
      font-size: 14px;
      margin: 0px;
      margin-bottom: 20px;
      padding: 20px 20px;
    }

    p {
      font-size: 12px;
      margin: 5px 20px 0px 20px;
      line-height: 17px;
      color: #909399;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      justify-content: space-between;
      text-align: left;
      border-bottom: 1px solid #EBEEF5;
      padding: 10px 0px;
      font-weight: 600;
      text-transform: uppercase;

      &.description {
        flex-direction: column-reverse;
        align-items: flex-start;
        margin-top: 25px;
        border: none;

        span {
          text-align: left;
          width: 100%;
        }
      }

      span {
        text-align: left;
        width: 80%;
        font-size: 13px;
        padding: 5px 0px;
        color: #606266;
        font-weight: 400;
        text-transform: none;
      }
    }
  }

  .status-block {
    @extend .info;
    border: none;
    margin-top: 0px;

    .status-card {
      display: flex;
      align-items: center;
      font-size: 12px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      background-color: white;

      span {
        display: block;
        height: 30px;
        width: 40px;
        background-color: #F56C6C;
        margin-right: 10px;
      }
    }
  }

  .header-info {
    text-align: center;
    width: 100%;
    padding: 15px 0px 20px 0px;
    h3 {
      font-size: 16px;
      margin: 0px;
      margin-top: 20px;
      line-height: 15px;
    }

    span {
      color: #909399;
      font-size: 12px;
    }

    .header-info-block {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 25px 0px;

      > * {
        height: 30px;
      }

      .status {
        border-right: 2px solid whitesmoke;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        font-size: 12px;
        color: #606266;
      }

      .public {
        @extend .status;
        border: none;

        i {
          padding-right: 10px;
        }
      }
    }
  }

  .bool-props {
    width: 50%;
    display: flex;
    flex-direction: column;

    .prop {
      font-size: 12px;
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/StationDetails.vue